export const filterSelector = (state) => state.filter;
export const rateSelector = (state) => state.rate;
export const styleSelector = (state) => state.style;
